module.exports = __webpack_public_path__ + "static/about_us-ddf446e04187d6f62927c6ddd4c59e15.jpg";